import React from "react";
import Banner from "../../components/templates/home/Loans/Banner";
import Cards from "../../components/templates/home/Loans/Cards";
import Benefits from "../../components/templates/home/Loans/Benefits";
import Repayment from "../../components/templates/home/Loans/Repayment";
import Clarifications from "../../components/templates/home/Loans/Clarifications";

const Contact = () => {
  return (
    <div>
      <Banner />
      <Cards />
      <Benefits />
      <Repayment />
      <Clarifications />
    </div>
  );
};

export default Contact;
